// error-interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse,
  HttpContextToken
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { JwtHelperService } from '@auth0/angular-jwt';

export const skipErrorToast = new HttpContextToken<boolean>(() => false);
export const allowedStatuses = new HttpContextToken<number[]>(() => []);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private jwt = new JwtHelperService();

  constructor(private toast: ToastService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipToast = req.context.get(skipErrorToast);
    const statuses = req.context.get(allowedStatuses) ?? [];
    const isLogout  = req.url.endsWith('auth/logout');

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const status = err.status ?? 0;
        const isAllowed = statuses?.includes(status) ?? false;
        const isLogoutCall = req.url.endsWith('auth/logout');
        if ((isLogout && (err.status === 401 || err.status === 404)) || statuses.includes(err.status) || skipToast) {
          return throwError(() => err);
        }

        // Detect if the current access token is already expired
        const raw = localStorage.getItem('prism-auth-token') || localStorage.getItem('authToken');
        const token = raw?.replaceAll('"', '');
        const tokenExpired = !token || this.jwt.isTokenExpired(token);

        // 1) Logout endpoint returning 401/404 → already logged out / not found
        // 2) Any 401 while token is already expired → session timeout path
        if (
          (isLogoutCall && (status === 401 || status === 404)) ||
          (status === 401 && tokenExpired)
        ) {
          return throwError(() => err);
        }

        if (skipToast || isAllowed) {
          return throwError(() => err);
        }

        return throwError(() => err);
      })
    );
  }
}
